import React from 'react';
import { useSelector } from 'react-redux';
// import { Link } from 'react-router-dom';
import Spinner from './../Spinner';

import './Inclusions.css';

const defaultItems = [
  { icon: '/assets/inclusion/cab-assistance.svg', value: 'Cab Assistance' },
  { icon: '/assets/inclusion/emergency-accident.svg', value: 'Emergency Accident Towing Assistance' },
  { icon: '/assets/inclusion/key.svg', value: 'Car Key Repairs' },
  { icon: '/assets/inclusion/emergency-accident.svg', value: 'Emergency Car Breakdown Services' },
  { icon: '/assets/inclusion/house.svg', value: 'Accommodation' },
  { icon: '/assets/inclusion/tyre.svg', value: 'Flat Tyre Service' },
  { icon: '/assets/inclusion/fuel.svg', value: 'Emergency Fuel Delivery' },
  { icon: '/assets/inclusion/coverage.svg', value: 'Coverage Area Emergency' },
];


const mapApiToIcons = (inclusion, defaultItems) => {
  return inclusion.map(item => {
    const matched = defaultItems.find(d => d.value === item);
    return {
      icon: matched?.icon || '/assets/inclusion/emergency-accident.svg',
      value: item,
    };
  });
};

const Inclusions = ({ vehicleType }) => {
  const reducerData = useSelector(state => state.priceList.apiResponse || {});
  const inclusionData = reducerData?.data?.inclusions || [];
  const mappedItems = mapApiToIcons(inclusionData, defaultItems);

  if (!inclusionData.length) {
    return (
      <Spinner />
    );
  }
  
  return (
    <div className="inclusions">
      <div className='list'>
          <div className='icons'>
          <img src='/assets/inclusion/inclusion.png' alt="Inclusdion of coverage" className="inclusion-icon" />
            <h3>Inclusions</h3>
          </div>
        <p>
        We offer 24/7 roadside support to get you back on the road quickly and safely from minor hiccups to major halts. We provide complete on-the-spot support for your vehicle.
        </p>
        <div className='ul-list'>
          <ul>
            {mappedItems.map((item, idx) => (
              <li key={idx} className="inclusion-item">
                <img src={item.icon} alt={item.value} className="inclusion-icon" />
                <span className='inclusion-text'>{item.value}</span>
              </li>
            ))}
          </ul>
          {/* <div className="view-all">
            <Link to="/membership-features" state={reducerData}>View All Membership Features</Link>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Inclusions;
